import { wrapInApolloProvider } from 'owa-apollo/lib/react';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { DrawerPane } from 'owa-drawer';
import { observer } from 'owa-mobx-react';
import {
    TimePanel as LazyTimePanel,
    TimePanelHeaderBar as LazyTimePanelHeaderBar,
} from 'owa-time-panel/lib/lazyCalendarBoot';
import closeHeaderPane from '../../orchestration/closeHeaderPane';
import type { OwaHeaderPaneProps } from '../../types/OwaHeaderPaneProps';
import { bodyContainer, header } from './MyDayPane.scss';
import type { FunctionComponent } from 'react';

const onMyDayClosePane = () => {
    closeHeaderPane(getDrawerPaneId('myDay'));
};

const myDayPaneTitle = () => {
    return <LazyTimePanelHeaderBar onClosePanel={onMyDayClosePane} />;
};

const defaultExport: FunctionComponent<OwaHeaderPaneProps> = observer(function MyDayPane(
    props: OwaHeaderPaneProps
) {
    return wrapInApolloProvider(
        <DrawerPane
            paneId={props.paneId}
            headerText={myDayPaneTitle()}
            headerClassName={header}
            bodyClassName={bodyContainer}
            noPadding={true}
            role={'complementary'}
        >
            <LazyTimePanel onClosePanel={onMyDayClosePane} />
        </DrawerPane>
    );
},
'MyDayPane');
export default defaultExport;
